import React, { createContext, ReactNode, useContext, useState } from 'react';

type DynamicHeaderContextType = {
  setPageDescription: (description?: string) => void;
  pageDescription: string | undefined;
};

const defaultContext: DynamicHeaderContextType = {
  setPageDescription: () => {},
  pageDescription: undefined,
};

export const DynamicHeaderContext = createContext<DynamicHeaderContextType>(defaultContext);

export const useDynamicHeaderContext = () => useContext(DynamicHeaderContext);

export const DynamicHeaderContextProvider = ({ children }: { children: ReactNode }) => {
  const [pageDescription, setPageDescription] = useState<string | undefined>(undefined);

  return (
    <DynamicHeaderContext.Provider value={{ pageDescription, setPageDescription }}>
      {children}
    </DynamicHeaderContext.Provider>
  );
};
